module.exports = __webpack_public_path__ + "img/76.5.COD.c357b2be.png";